define('OutSystems/ClientRuntime/Flow',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.whileTrueAsync = exports.doWhileAsync = exports.forEachAsync = exports.whileAsync = exports.executeAsyncFlow = exports.tryFinally = exports.tryCatch = exports.tryCatchFinally = exports.executeSequence = exports.throwAsync = exports.returnAsync = exports.continueAsync = exports.breakAsync = exports.resolve = exports.promise = exports.isPromiseCompatible = void 0;
    var MethodSignalReturn = (function () {
        function MethodSignalReturn(returnValue) {
            this.returnValue = returnValue;
        }
        return MethodSignalReturn;
    }());
    var LOOP_SIGNAL_BREAK = new Object();
    var LOOP_SIGNAL_CONTINUE = new Object();
    function isPromiseCompatible(target) {
        var promise = target;
        return promise && typeof promise.then === "function" && typeof promise.catch === "function";
    }
    exports.isPromiseCompatible = isPromiseCompatible;
    function handleLoopSignal(loop, signal) {
        switch (signal) {
            case LOOP_SIGNAL_CONTINUE:
                return loop();
            case LOOP_SIGNAL_BREAK:
                return undefined;
            default:
                return Promise.reject(signal);
        }
    }
    function createLoopCond(cond) {
        return cond() ? Promise.resolve(undefined) : breakAsync();
    }
    function promise(callback) {
        return new Promise(callback);
    }
    exports.promise = promise;
    function resolve(value) {
        return Promise.resolve(value);
    }
    exports.resolve = resolve;
    function breakAsync() {
        return Promise.reject(LOOP_SIGNAL_BREAK);
    }
    exports.breakAsync = breakAsync;
    function continueAsync() {
        return Promise.reject(LOOP_SIGNAL_CONTINUE);
    }
    exports.continueAsync = continueAsync;
    function returnAsync(returnValue) {
        return Promise.reject(new MethodSignalReturn(returnValue));
    }
    exports.returnAsync = returnAsync;
    function throwAsync(exception) {
        return Promise.reject(exception);
    }
    exports.throwAsync = throwAsync;
    function executeSequence(f) {
        return innerExecuteSequence(f);
    }
    exports.executeSequence = executeSequence;
    function innerExecuteSequence(f, errorTimeoutHandle) {
        var result = undefined;
        var error = undefined;
        var raiseError = function () {
            throw error;
        };
        var postponeRaiseError = function () {
            clearTimeout(errorTimeoutHandle);
            errorTimeoutHandle = setTimeout(raiseError, 0);
        };
        function handleResult(onFulfilled, onRejected) {
            if (error) {
                if (onRejected) {
                    clearTimeout(errorTimeoutHandle);
                    return innerExecuteSequence(function () { return onRejected(error); });
                }
                postponeRaiseError();
                return innerExecuteSequence(raiseError, errorTimeoutHandle);
            }
            if (onFulfilled) {
                return innerExecuteSequence(function () { return onFulfilled(result); });
            }
            return innerExecuteSequence(function () { return result; });
        }
        try {
            result = f();
        }
        catch (e) {
            error = e;
            postponeRaiseError();
        }
        if (isPromiseCompatible(result)) {
            return result;
        }
        return {
            then: function (onFulfilled, onRejected) {
                return handleResult(onFulfilled, onRejected);
            },
            catch: function (onRejected) {
                return handleResult(undefined, onRejected);
            },
        };
    }
    function tryCatchFinally(tryBranch, catchBranch, finallyBranch) {
        if (catchBranch === void 0) { catchBranch = function (e) { return Promise.reject(e); }; }
        if (finallyBranch === void 0) { finallyBranch = function () { return Promise.resolve(undefined); }; }
        return executeSequence(tryBranch)
            .catch(catchBranch)
            .then(function (returnValue) {
            return executeSequence(finallyBranch).then(function (finallyReturnValue) {
                return finallyReturnValue !== undefined ? finallyReturnValue : returnValue;
            });
        }, function (error) { return executeSequence(finallyBranch).then(function () { return Promise.reject(error); }); });
    }
    exports.tryCatchFinally = tryCatchFinally;
    function tryCatch(tryFunction, catchFunction) {
        return tryCatchFinally(tryFunction, catchFunction, undefined);
    }
    exports.tryCatch = tryCatch;
    function tryFinally(tryFunction, finallyFunction) {
        return tryCatchFinally(tryFunction, undefined, finallyFunction);
    }
    exports.tryFinally = tryFinally;
    function executeAsyncFlow(x) {
        if (x === void 0) { x = function () { return void 0; }; }
        return executeSequence(x).catch(handleReturnSignal);
    }
    exports.executeAsyncFlow = executeAsyncFlow;
    function whileAsync(cond, body) {
        function loop() {
            return createLoopCond(cond).then(body).then(loop, handleLoopSignal.bind(null, loop));
        }
        return loop();
    }
    exports.whileAsync = whileAsync;
    function forEachAsync(arr, body) {
        var i = 0;
        return whileAsync(function () { return i < arr.length; }, function () {
            var elem = arr[i++];
            return body(elem);
        });
    }
    exports.forEachAsync = forEachAsync;
    function doWhileAsync(cond, body) {
        function conditionAndLoop() {
            return createLoopCond(cond).then(loop, handleLoopSignal.bind(null, loop));
        }
        function loop() {
            return executeSequence(body)
                .then(function () { return createLoopCond(cond); })
                .then(loop, handleLoopSignal.bind(null, conditionAndLoop));
        }
        return loop();
    }
    exports.doWhileAsync = doWhileAsync;
    exports.whileTrueAsync = whileAsync.bind(null, function () { return true; });
    function handleReturnSignal(signal) {
        if (signal instanceof MethodSignalReturn) {
            return signal.returnValue;
        }
        else {
            return Promise.reject(signal);
        }
    }
});
//# sourceMappingURL=Flow.js.map;
